/* Kudeko · medición Espacios v1. Solo eventos propios; NO configura gtag, NO envía purchase.
   No fotos, nombres de espacios, prompts, emails, cookies ni identificadores de comprador.
   Si no hay permiso analítico verificable, no se almacena ni se encola la interacción. */
(() => {
  'use strict';
  if (window.KdkPreviewAnalytics) return;
  const config = window.KDK_SPACES_CONFIG || {};
  const options = config.analytics || {};
  const measurementId = options.measurementId || 'G-V54BYS63QJ';
  const query = new URLSearchParams(location.search);
  const debug = query.get('kdk_preview_debug') === '1';
  const environment = config.environment !== 'production' || window.Shopify?.designMode ||
    window.Shopify?.theme?.role === 'unpublished' || query.has('preview_theme_id') || debug ? 'test' : 'production';
  const enabled = options.enabled === true && (!window.Shopify?.designMode || debug);
  let owners = new WeakMap(), pendingCart = null, viewer = null, lastTrigger = null, latestSpaceCount = null;
  // Entry intent is not an analytics session. Keep it across consent changes while the
  // editor is open, and remove it on close even when analytics never had permission.
  const galleryOwners = new WeakSet();
  let permissionEpoch = 0, privacyRequested = false, queue = [], timer = null;
  const counters = { queued: 0, sent_to_tag: 0, dropped: 0, errors: 0 };
  const allowedNames = new Set(['kdk_preview_open','kdk_preview_ready','kdk_preview_edit','kdk_preview_generate',
    'kdk_preview_result','kdk_preview_error','kdk_preview_action','kdk_preview_item','kdk_space_save','kdk_space_open','kdk_space_delete']);
  const numeric = new Set(['product_count','panel_count','space_count','duration_ms','item_index','linked_frames','linked_sizes','selection_count']);
  const strings = new Set(['generation_id','space_id','save_id','action','stage','generation_kind','provider',
    'error_stage','error_code','product_id','variant_id','frame_type','frame_color','frame_source','consent_late','gallery_state']);
  const galleryActions = new Set(['gallery_available','gallery_impression','gallery_camera','gallery_upload',
    'gallery_use_space','gallery_change_space','gallery_cached_view']);
  const galleryStates = new Set(['empty','room','render']);
  const galleryErrors = new Set(['load_failed','open_failed','space_load_failed','storage','storage_unavailable',
    'missing_product','variant_unavailable','photo_decode','image_decode','capacity','cancelled','unknown']);
  function uuid() { return crypto.randomUUID(); }
  function id(value) { const s=String(value || ''); return /^[a-zA-Z0-9_-]{1,90}$/.test(s) ? s : ''; }
  function safeCall(fn) { return (...args) => { try { return fn(...args); } catch (_) { counters.errors++; return null; } }; }
  function requestPrivacy() {
    if (privacyRequested || window.Shopify?.customerPrivacy || !window.Shopify?.loadFeatures) return;
    privacyRequested = true;
    try { window.Shopify.loadFeatures([{ name:'consent-tracking-api', version:'0.1' }], () => {
      document.dispatchEvent(new CustomEvent('kdk:preview:analytics-ready'));
    }); } catch (_) {}
  }
  function permitted() {
    if (!enabled) return false;
    const p = window.Shopify?.customerPrivacy;
    if (!p) { requestPrivacy(); return false; }
    try {
      if (p.currentVisitorConsent?.().analytics === 'no') return false;
      return p.analyticsProcessingAllowed?.() === true;
    } catch (_) { return false; }
  }
  function clearPermission() {
    permissionEpoch++; owners = new WeakMap(); pendingCart = null; viewer = null; latestSpaceCount = null;
    counters.dropped += queue.length; queue = []; if (timer) clearTimeout(timer); timer = null;
  }
  document.addEventListener('visitorConsentCollected', () => { if (!permitted()) clearPermission(); });
  function cleanParams(extra) {
    const out = {};
    for (const [key,value] of Object.entries(extra || {})) {
      if (numeric.has(key)) { const n=Number(value); if(Number.isFinite(n))out[key]=Math.max(0,Math.min(10000000,Math.round(n))); }
      else if (strings.has(key) && value != null) {
        const s=String(value); // All accepted values are internal enums/IDs, never user-entered text.
        if (/^[a-zA-Z0-9_-]{1,90}$/.test(s)) out[key]=s;
      }
    }
    return out;
  }
  function flush() {
    timer = null;
    if (!permitted()) { counters.dropped+=queue.length; queue=[]; return; }
    const now=Date.now();
    if (typeof window.gtag !== 'function') {
      const live=queue.filter(e=>now-e.at<5000); counters.dropped+=queue.length-live.length; queue=live;
      if(queue.length)timer=setTimeout(flush,250); return;
    }
    const batch=queue;queue=[];
    for(const e of batch){
      if(e.epoch!==permissionEpoch || !permitted()){counters.dropped++;continue;}
      try{window.gtag('event',e.name,e.params);counters.sent_to_tag++;}catch(_){counters.errors++;}
    }
  }
  function emit(context,name,extra={}) {
    if(!context || context.closed || context.epoch!==permissionEpoch || !permitted() || !allowedNames.has(name))return false;
    const params={send_to:measurementId,kdk_schema:'1',kdk_environment:environment,kdk_event_id:uuid(),
      entry_point:context.entry,...cleanParams(extra)};
    // Gallery impressions/actions precede the editor; they must not manufacture an
    // opening or inherit the session of an editor that was previously closed.
    if(context.id)params.preview_session_id=context.id;
    if(context.mode)params.preview_mode=context.mode;
    if(debug)params.debug_mode=true;
    if(queue.length>=120){counters.dropped++;return false;}
    queue.push({name,params,at:Date.now(),epoch:permissionEpoch});counters.queued++;
    if(!timer)timer=setTimeout(flush,0);
    return true;
  }
  function source(owner) {
    if(owner?.cartContext || owner?._cartSelection)return 'cart';
    if(owner && galleryOwners.has(owner))return 'product_gallery';
    if(query.has('kdk_edit_space'))return 'saved_space';
    if(owner?.rootEl?.closest?.('[data-kdk-preview-host],.kdk-native-preview-host'))return 'collection';
    if(lastTrigger && Date.now()-lastTrigger.at<30000)return lastTrigger.entry;
    const p=options.pageType || '';
    if(p==='collection'||p==='search'||/\/(collections|search)(\/|$)/.test(location.pathname))return 'collection';
    if(p==='product'||/\/products\//.test(location.pathname))return 'product';
    return 'unknown';
  }
  function entry(owner) { return owners.get(owner)?.entry || source(owner); }
  function context(entry,mode='ai') {return {id:uuid(),entry,mode,epoch:permissionEpoch,closed:false,ready:new Set(),edited:new Set(),frames:new Map(),results:new Set()};}
  function start(owner,late=false) {
    if(!permitted())return null;
    let c=owners.get(owner);if(c && !c.closed && c.epoch===permissionEpoch)return c;
    if(owner.cartContext && pendingCart && !pendingCart.closed && pendingCart.epoch===permissionEpoch){c=pendingCart;pendingCart=null;}
    else {c=context(source(owner),owner.mode || (config.previewModes==='ai_only'?'ai':'chooser'));
      emit(c,'kdk_preview_open',late?{consent_late:'yes'}:{});}
    owners.set(owner,c);return c;
  }
  function get(owner) {return owners.get(owner) || (owner && owner.modalEl?.hidden===false ? start(owner,true) : null);}
  function galleryParams(extra={}) {
    const params={};
    // The gallery accepts only catalogue IDs and an opaque storage ID, not generic
    // analytics fields, names, URLs, photos, prompts or exception messages.
    for(const key of ['product_id','variant_id']){
      const match=String(extra[key]??'').match(/^(?:gid:\/\/shopify\/(?:Product|ProductVariant)\/)?(\d{1,30})$/);
      if(match)params[key]=match[1];
    }
    if(galleryStates.has(extra.gallery_state))params.gallery_state=extra.gallery_state;
    const space=String(extra.space_id??'');
    if(/^(?:[a-f0-9]{32}|[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})$/i.test(space))params.space_id=space;
    if(extra.space_count!=null){const count=Number(extra.space_count);if(Number.isFinite(count))params.space_count=Math.max(0,Math.min(5,Math.round(count)));}
    return params;
  }
  function gallery(actionName,extra={}) {
    if(!galleryActions.has(actionName))return false;
    return emit({entry:'product_gallery',epoch:permissionEpoch},'kdk_preview_action',{
      ...galleryParams(extra),action:actionName
    });
  }
  function galleryError(code,extra={}) {
    return emit({entry:'product_gallery',epoch:permissionEpoch},'kdk_preview_error',{
      ...galleryParams(extra),error_stage:'gallery',error_code:galleryErrors.has(code)?code:'unknown'
    });
  }
  function beginGallery(owner) {
    if(!owner || typeof owner!=='object' || owner.cartContext || owner._cartSelection)return false;
    galleryOwners.add(owner);return true;
  }
  function endGallery(owner) {return !!owner && galleryOwners.delete(owner);}
  function counts(items){const list=Array.isArray(items)?items:[];return{product_count:list.length,panel_count:list.reduce((n,i)=>n+Math.max(1,Number(i.panelCount)||1),0)};}
  function scene(owner){const e=owner?._guided;return{...counts(e?.items),space_count:e?.galleryRows?.length||0,linked_frames:e?.sameFrame?1:0,linked_sizes:e?.equalSizes?1:0};}
  function mode(owner,value){const c=get(owner);if(!c||c.mode===value)return;c.mode=value==='manual'?'manual':'ai';emit(c,'kdk_preview_action',{action:'mode_select'});}
  function ready(owner){if(owner?._kdkGalleryPreparing)return;const e=owner?._guided,c=get(owner);if(!c||owner.mode!=='ai'||!e?.photo||!e.items?.length||e.loading||e.capacityBlocked())return;
    const key=id(e.sceneId);if(c.ready.has(key))return;
    c.ready.add(key);emit(c,'kdk_preview_ready',scene(owner));
  }
  function edit(owner,action='move'){const c=get(owner),key=id(owner?._guided?.sceneId);if(!c||c.edited.has(key))return;
    ready(owner);c.edited.add(key);emit(c,'kdk_preview_edit',{...scene(owner),action});}
  function action(owner,value,extra={}){const c=get(owner);emit(c,'kdk_preview_action',{...scene(owner),action:value,...extra});}
  function frame(owner,items,linked){const c=get(owner);if(!c)return;edit(owner,'frame');
    for(const it of items||[]){c.frames.set(it.id,true);emit(c,'kdk_preview_action',{action:'frame_change',product_id:it.productId,variant_id:it.variantId,
      frame_type:it.frame?.type,frame_color:it.frame?.color,panel_count:Number(it.panelCount)||1,linked_frames:linked?1:0});}
  }
  function itemEvents(c,items,stage,extra={}){(items||[]).slice(0,6).forEach((it,n)=>emit(c,'kdk_preview_item',{
    ...extra,stage,item_index:n+1,product_id:it.productId,variant_id:it.variantId,panel_count:Number(it.panelCount)||1,
    frame_type:it.frame?.type,frame_color:it.frame?.color,frame_source:c.frames.has(it.id)?'changed':c.entry==='cart'?'cart_variant':'initial_or_saved'}));}
  function generate(owner,generationId,kind){const c=get(owner);if(!c)return;ready(owner);
    emit(c,'kdk_preview_generate',{...scene(owner),generation_id:id(generationId),generation_kind:kind});}
  function result(owner,generationId,items,provider,duration){const c=get(owner);if(!c||c.results.has(generationId))return;
    c.results.add(generationId);const extra={generation_id:id(generationId),provider};
    emit(c,'kdk_preview_result',{...scene(owner),...extra,duration_ms:duration});itemEvents(c,items,'result',extra);
  }
  function error(owner,stage,code,generationId){const c=owner?get(owner):pendingCart;
    // Codes come only from known internal categories; raw exception messages are never transmitted.
    const allowed=new Set(['photo_decode','request_failed','timeout','cancelled','invalid_response','image_decode','aspect_ratio','catalogue','storage','capacity','load_failed','unknown']);
    emit(c,'kdk_preview_error',{error_stage:stage,error_code:allowed.has(code)?code:'unknown',generation_id:id(generationId)});
  }
  function save(owner,meta,update,snapshot){const c=get(owner);if(!c)return;const extra={generation_id:id(snapshot?.token),save_id:uuid(),space_id:id(meta.id)};
    emit(c,'kdk_space_save',{...counts(snapshot?.items),space_count:latestSpaceCount ?? owner._guided?.galleryRows?.length ?? 0,...extra,action:update?'update':'create'});
    itemEvents(c,snapshot?.items,'save',extra);
  }
  function space(owner,meta,actionName='edit'){
    let c=owner?get(owner):viewer;
    if(!owner && permitted() && (!c||c.closed||c.epoch!==permissionEpoch)){viewer=context('saved_space');c=viewer;}
    emit(c,'kdk_space_open',{...counts(meta.items),space_id:id(meta.id),action:actionName});
  }
  function viewerAction(owner,meta,value,item){const c=owner?get(owner):viewer;
    emit(c,'kdk_preview_action',{...counts(meta?.items),action:value,space_id:id(meta?.id),product_id:item?.productId,variant_id:item?.variantId});}
  function deleted(owner,spaceId){emit(owner?get(owner):(pendingCart||viewer),'kdk_space_delete',{space_id:id(spaceId)});}
  function end(owner){const c=owners.get(owner);if(c){emit(c,'kdk_preview_action',{action:'close'});c.closed=true;owners.delete(owner);}endGallery(owner);}
  function cartStart(){if(!permitted())return;pendingCart=context('cart',config.previewModes==='ai_only'?'ai':'chooser');emit(pendingCart,'kdk_preview_open');}
  function cartMode(m){if(pendingCart){pendingCart.mode=m;emit(pendingCart,'kdk_preview_action',{action:'mode_select'});}}
  function cartSelect(n){if(!pendingCart&&permitted()){pendingCart=context('cart');emit(pendingCart,'kdk_preview_open',{consent_late:'yes'});}emit(pendingCart,'kdk_preview_action',{action:'cart_selection',selection_count:n});}
  function cartClose(){if(pendingCart){emit(pendingCart,'kdk_preview_action',{action:'close'});pendingCart.closed=true;pendingCart=null;}}
  document.addEventListener('kdk:spaces:changed', e=>{
    if(!permitted())return;
    const rows=e.detail?.rows; if(Array.isArray(rows))latestSpaceCount=rows.length;
  });
  document.addEventListener('click', e=>{
    const target=e.target?.closest?.('[data-kdk-card-action="visualizer"],[data-kdk-preview-shell-open],[data-kdk-preview-open]');
    if(!target)return;
    if(target.matches('[data-kdk-card-action="visualizer"],[data-native-visualize]')||target.closest('[data-kdk-preview-host],.kdk-native-card,.kdk-native-quick-dialog,.ProductItem'))lastTrigger={entry:'collection',at:Date.now()};
    else if(target.hasAttribute('data-kdk-preview-shell-open'))lastTrigger={entry:'product',at:Date.now()};
  },true);
  const api={start,mode,ready,edit,action,frame,generate,result,error,save,space,viewerAction,deleted,end,cartStart,cartMode,cartSelect,cartClose,source,entry,
    gallery,galleryError,beginGallery,endGallery};
  window.KdkPreviewAnalytics=Object.fromEntries(Object.entries(api).map(([name,fn])=>[name,safeCall(fn)]));
  window.KdkPreviewAnalytics.environment=environment;
  window.KdkPreviewAnalytics.debug=()=>({version:1,enabled,measurementId,environment,privacyAvailable:!!window.Shopify?.customerPrivacy,
    analyticsAllowed:permitted(),gtagAvailable:typeof window.gtag==='function',queued:queue.length,counters:{...counters}});
  window.addEventListener('pagehide',safeCall(flush));
  document.dispatchEvent(new CustomEvent('kdk:preview:analytics-ready'));
})();

